const root = `td-system/deptAppend/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'list',
  getDeptAppendList: root + 'selectCaseHanding',
  remove: root + 'remove',
  add: root + 'save',
  update: root + 'update'
}
// 查看详情
export const getDetail = id => {
  return $http.get(`${urls.getDetail}?id=${id}`)
}
// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}

export const getDeptAppendList = deptId => {
  return $http.get(`${urls.getDeptAppendList}?deptId=${deptId}`)
  //return $http.get(urls.getDeptAppendList, obj)
}
// 新增
export const add = obj => {
  return $http.post(urls.add, obj)
}
// 更新
export const update = obj => {
  return $http.post(urls.update, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}
export default {
  getDetail,
  getList,
  getDeptAppendList,
  add,
  update,
  remove
}
